var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.663 7.737h-13.861v-0.533c0-1.178-0.955-2.133-2.133-2.133h-5.331c-1.178 0-2.132 0.955-2.132 2.133v17.593c0 1.178 0.955 2.133 2.132 2.133h21.325c1.178 0 2.133-0.955 2.133-2.133v-14.928c0-1.178-0.955-2.133-2.133-2.133zM4.271 7.203c0-0.588 0.479-1.066 1.066-1.066h5.331c0.588 0 1.066 0.478 1.066 1.066v1.599h14.928c0.588 0 1.066 0.478 1.066 1.066v1.066h-23.457v-3.732zM26.663 25.863h-21.325c-0.588 0-1.066-0.479-1.066-1.066v-12.795h23.457v12.795c0 0.588-0.479 1.066-1.066 1.066z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.fefb6b92182e971809cc5766d22128d7.svg";
export { ForwardRef as ReactComponent };